import React, { useState, useCallback, useEffect } from 'react';
import { useForm } from 'react-hook-form';
// @mui
import { styled } from '@mui/material/styles';
import { Typography, Stack, Avatar, Select, MenuItem } from '@mui/material';
// auth
import FormProvider, { RHFSelect } from '../../../components/hook-form';
// import { useAuthContext } from '../../../auth/useAuthContext';
import AppCache from '../../../services/appcache';
// ---------------------------------------------------------------------------------------------------------

const StyledRoot = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    // padding: theme.spacing(2, 2.5),
    padding: theme.spacing(0.5, 2.5),
    // borderRadius: Number(theme.shape.borderRadius) * 1.5,
    // backgroundColor: alpha(theme.palette.grey[500], 0.12),
}));
// ---------------------------------------------------------------------------------------------------------

const userRoles = [
    { id: 1, name: 'Sales Manager' },
    { id: 2, name: 'Supervisor' },
    { id: 3, name: 'Field Staff' }
];
// ---------------------------------------------------------------------------------------------------------

export default function SalesNavAccount() {

    // const { user } = useAuthContext();
    const currentLoggedInUser = AppCache.GetCurrentLoggedInUser();
    // const empTerritory = AppCache.GetEmpTerritory();
    // const empTerritory = AppCache.GetSalesUserTerritory();
    const userName = `${currentLoggedInUser.UserFirstName} ${currentLoggedInUser.UserLastName}` || currentLoggedInUser.UserName;

    // const franchises = empTerritory?.Franchise.split(", ");
    // const territories = empTerritory?.Territory.split(", ");
    // const empLevels = empTerritory?.EmpLevel.split(", ");

    /* const salesUserData = franchises?.map((franchise, index) => ({
         id: index + 1,
         Franchise: franchise,
         Territory: territories[index] || "",
         EmpLevel: empLevels[index] || ""
     }));    */

    // const [franchise, setFranchise] = useState("");
    // const [territory, setTerritory] = useState("");
    // const [empLevel, setEmpLevel] = useState("");

    /*  useEffect(() => {
          if (salesUserData?.length > 0) {
              setFranchise(salesUserData[0]?.Franchise);
              setTerritory(salesUserData[0]?.Territory);
              setEmpLevel(salesUserData[0]?.EmpLevel);
              // AppCache.SetEmpTerritory(salesUserData[0]?.Franchise, salesUserData[0]?.Territory, salesUserData[0]?.EmpLevel);
          }
          // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [])  */

    const methods = useForm({});

    /*  const handleFranchise = useCallback((event) => {
          const selectedFranchise = event.target.value;
  
          // Find the corresponding territory based on the selected franchise
          const selectedIndex = salesUserData.findIndex((item) => item.Franchise === selectedFranchise);
          let newTerritory;
          let newEmpLevel;
  
          if (selectedIndex !== -1) {
              newTerritory = salesUserData[selectedIndex].Territory;
              newEmpLevel = salesUserData[selectedIndex].EmpLevel;
  
              setFranchise(selectedFranchise);
              setTerritory(newTerritory);
              setEmpLevel(newEmpLevel);
          }
  
          AppCache.SetEmpTerritory(selectedFranchise, newTerritory, newEmpLevel);
          window.location.reload();
      }, [salesUserData]);    */

    /*  useEffect(() => {
        if (franchise && territory && empLevel) {
            AppCache.SetEmpTerritory(franchise, territory, empLevel);
        }
    }, [franchise, territory, empLevel])    */


    // const selectedFranchise = AppCache.GetEmpTerritory();

    return (
        <StyledRoot>
            {/* <CustomAvatar src={user?.photoURL} alt={user?.displayName} name={user?.displayName} />
            <Box sx={{ ml: 2, minWidth: 0 }}>
                <Typography variant="subtitle2" noWrap>
                    {user?.displayName}
                </Typography>

                <Typography variant="body2" noWrap sx={{ color: 'text.secondary' }}>
                    {user?.role}
                </Typography>
            </Box> */}

            <FormProvider methods={methods}>
                {/* <Stack direction='row' justifyContent='space-between' spacing={2} flexGrow={1} sx={{ mx: 4, mb: 1 }}>
                <Avatar src={currentLoggedInUser.ProfileImage} alt="photoURL" />    */}
                <Stack direction='column' justifyContent='space-between' flexGrow={1} >
                    <Typography variant="subtitle2" sx={{ color: 'common.black' }}>
                        {userName}
                    </Typography>

                    <Typography variant="caption" sx={{ color: 'common.black' }}>
                        {currentLoggedInUser.UserRoleName}
                    </Typography>

                    {/*   <Stack direction='row' justifyContent='space-between' spacing={0.4}>
                        <Typography variant="subtitle2" sx={{ color: 'common.black', fontSize: 12, mt: 0.5 }}>
                            Franchise :
                        </Typography>

                        <RHFSelect
                            name="franchise"
                            size='small'
                            sx={{
                                width: 150,
                                height: 30, // Adjust height as needed
                                '& .MuiOutlinedInput-root': {
                                    minHeight: 30, // Ensures the input field itself has less height
                                    padding: '2px 6px', // Reducing padding makes it smaller
                                },
                                '& .MuiSelect-select': {
                                    padding: '2px 6px' // Controls padding inside the select
                                }
                            }}
                            value={selectedFranchise?.Franchise || franchise}
                            onChange={handleFranchise}>
                            {salesUserData && salesUserData.map((data) => (
                                <MenuItem key={data.id} value={data.Franchise}>
                                    {data.Franchise}
                                </MenuItem>
                            ))}
                        </RHFSelect>
                    </Stack>    

                    <Typography variant="subtitle2" sx={{ color: 'common.black', fontSize: 12, pt: 0.5 }}>
                        Territory : {selectedFranchise?.Territory || territory}
            </Typography>   */}
                </Stack>
            </FormProvider >
        </StyledRoot >
    );
}
